class ColorBgBlock extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = null;
        this._swiperInstance = null;
        this._blockCount = this.dataset.count;
        this._spaceBetween = this.dataset.spacebetween;
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this._swiperContainer = this.querySelector('.swiper');
            this.initializeSwiper();
        });
    }

    disconnectedCallback() {
    }


    initializeSwiper() {
        if (!this._swiperContainer) {
            console.error('Swiper container not found');
            return;
        }

        const nextButton = this._swiperContainer.querySelector('.swiper-button-next');
        const prevButton = this._swiperContainer.querySelector('.swiper-button-prev');
        this._swiperInstance = new Swiper(this._swiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: this._blockCount,
            spaceBetween: this._spaceBetween,
            enabled: false,
            loop: false,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                    spaceBetween: 12,
                    enabled: true,
                },
                768: {
                    slidesPerView: 2.3,
                    enabled: true,
                },
                820: {
                    slidesPerView: 3,
                    enabled: true,
                },
                1180: {
                    enabled: false,
                    slidesPerView: this._blockCount,
                },
            },
        });
    }
}

customElements.define('color-bg-block-swiper', ColorBgBlock);